import React from 'react';

import Navigation from '../Navigation';

export default function CatSnapshotFooter() {
	return (
		<div className="server-footer alt-color--shadow">
			<div className="server-footer__contents">
				<Navigation />
				<div className="server-footer__credits alt-color--lighter">
					Made by <a className="site-link" href="https://twitter.com/lslez" target="_blank" rel="noopener noreferrer">@lslez</a>
				</div>
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/Site/CatSnapshot/CatSnapshotFooter.js